import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { useQueryParams } from 'hooks/useQueryParams/useQueryParams';
import { Hazard } from 'features/hazards/hazard.types';
import { GeoEventEditorLayout } from 'features/geoEvents/components/GeoEventEditorLayout';
import { useAuthState } from 'state/useAuthState';
import { HazardForm } from './HazardForm';

type HazardQueryParams = {
  parentGeoEventId?: string | null;
  parentGeoEventType?: 'wildfire' | 'flooding' | null;
};

export const CreateEditHazard = (
  props: RouteComponentProps<{ hazardId?: string }>,
): JSX.Element => {
  const {
    match: {
      params: { hazardId },
    },
  } = props;
  const { t } = useTranslation();
  const [{ parentGeoEventId, parentGeoEventType }] =
    useQueryParams<HazardQueryParams>();
  const {
    permissions: { canReportHazard },
  } = useAuthState();

  return (
    <GeoEventEditorLayout
      id={hazardId}
      hasAccess={canReportHazard}
      createHelmetTitle={t('createEditHazard.title.add')}
      editHelmetTitle={t('createEditHazard.title.edit')}
      renderSuccess={(geoEvent) => (
        <HazardForm
          hazard={geoEvent as unknown as Hazard}
          parentGeoEventId={
            parentGeoEventId ? parseInt(parentGeoEventId, 10) : undefined
          }
          parentGeoEventType={parentGeoEventType ?? undefined}
        />
      )}
    />
  );
};
